import React from 'react';

const SeverityDot = (props) => {
  const severity = (props.severity) ? props.severity : 'none';
  const className = `severity-dot mod-${severity}`;

  return (
    <span
      className={className}
      data-pt-tooltip={props.tooltip}
      data-pt-tooltip-position={props.tooltipPosition}
    />
  );
};

export default SeverityDot;
